import React from 'react'
import './style.css'
import { Button } from '../index'

interface PrescriptionTypeModalProps {
  closeModal: () => void
  onSelectMevo: () => void
  onSelectMemed: () => void
  disableMemed?: boolean
}

const PrescriptionTypeModal: React.FunctionComponent<
  PrescriptionTypeModalProps
> = ({ closeModal, onSelectMevo, onSelectMemed, disableMemed }) => {
  return (
    <div className="modal-container">
      <h2>Selecione o tipo de prescrição</h2>
      <p>Escolha por qual plataforma deseja emitir a prescrição médica.</p>
      <div
        className="buttons-modal"
        style={{ flexDirection: 'column', gap: 10 }}
      >
        <Button
          type="button"
          color="primary-light"
          size="normal"
          styles={{ width: '100%' }}
          onClick={() => {
            onSelectMevo()
            closeModal()
          }}
          title="Iniciar prescrição pela Mevo"
        >
          Mevo
        </Button>
        <Button
          type="button"
          color="primary-light"
          size="normal"
          styles={{ width: '100%' }}
          disabled={disableMemed}
          onClick={() => {
            onSelectMemed()
            closeModal()
          }}
          title="Iniciar prescrição pela Memed"
        >
          Memed
        </Button>
        <Button
          type="button"
          color="link-danger"
          onClick={() => closeModal()}
          styles={{
            marginTop: 10,
            border: '1px solid red',
            width: '100%',
          }}
        >
          Cancelar
        </Button>
      </div>
    </div>
  )
}

export default PrescriptionTypeModal
